import React from 'react'
import "./ads.css"
import adImg1 from "./image/web1.webp"
import adImg2 from "./image/61YzHSDo6zS._AC_UF1000,1000_QL80 new.jpg"
import { useNavigate } from 'react-router-dom'

function Ads() {
  const navigate = useNavigate();
  return (
    <div className='ads-container'>
      <div className="ad1">
        <img src={adImg2} alt="" className="ad-img1" />
        <div className="ad1-content">
          <div className="ad1-text">
            <p>SPORT Q100</p>
            <h3>FEEL COMFORT<br />FUEL FITNESS</h3>
            <div className="btn-container">
              <button className="ad-btn" onClick={() => navigate("/category/2")}>$59.99 ONLY</button>
            </div>
          </div>
        </div>
      </div>
      <div className="ad1 ad2">
        <img src={adImg1} alt="" className="ad-img2" />
        <div className="ad2-content">
          <div className="ad2-text">
            <p>ALL-NEW</p>
            <h3>PORTABLE<br />SPEAKERS</h3>
            <div className="btn-container">
              <button className="ad-btn" onClick={() => navigate("/category/3")}>$59.99 ONLY</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Ads
